var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220.14 35.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#06559e;}.cls-2{fill:#e12427;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lager_1-2",
    "data-name": "Lager 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.3,35.15V0h13V35.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.69,35.15,149.17,7.46,151,0h8.71L169,35.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.62,35.15,164.26,8l1.63-8h8.72l9.33,35.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.38,35.15,148,12l6.3,23.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.86,0H67.7V20.62h3c5.76,0,11-2.58,11-10.16C81.69,4.9,77.78,0,70.86,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.81,
    y: 0.01,
    width: 12.96,
    height: 35.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.94,35.15,98.61,18.74h2.23c5.23,0,10-2.95,10-9.23,0-5.06-3.56-9.5-9.85-9.5H98.11V18.74h0V35.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.83 35.15 215.05 35.14 207.5 0 193.66 0.01 198.23 19.67 195.71 19.67 192.41 5.29 184.92 35.15 199.26 35.15 196.41 22.71 198.93 22.71 201.83 35.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,35.15V26.88c4.6,0,11.28-7.37,16.65-13.3C23.24,6.3,28.94,0,35.14,0V8.28c-2.73,0-8.47,6.33-12.66,11C15.4,27.06,8.07,35.15,0,35.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 17.78 0 0.01 17.77 0.01 0 17.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.14 17.38 35.14 35.15 17.37 35.15 35.14 17.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.92,7.14a4.16,4.16,0,0,1-5.91,0,4,4,0,0,1-1.21-3A4,4,0,0,1,213,1.23,4,4,0,0,1,216,0a4.05,4.05,0,0,1,3,1.22,4,4,0,0,1,1.22,2.95A4,4,0,0,1,218.92,7.14Zm-5.49-5.5a3.47,3.47,0,0,0-1.05,2.54,3.49,3.49,0,0,0,1,2.56,3.59,3.59,0,0,0,5.09,0,3.52,3.52,0,0,0,1-2.56,3.5,3.5,0,0,0-1-2.54A3.46,3.46,0,0,0,216,.58,3.41,3.41,0,0,0,213.43,1.64Zm2.45.23a3.44,3.44,0,0,1,1.25.17,1.13,1.13,0,0,1,.72,1.16,1,1,0,0,1-.45.9,1.69,1.69,0,0,1-.66.23,1.06,1.06,0,0,1,.78.45,1.2,1.2,0,0,1,.25.71v.33c0,.11,0,.22,0,.34a.81.81,0,0,0,0,.24l0,.06h-.76a.09.09,0,0,0,0,0,.11.11,0,0,0,0,0l0-.15V5.85a1.12,1.12,0,0,0-.43-1,1.91,1.91,0,0,0-.9-.15h-.63V6.46h-.81V1.87Zm.88.72a2.18,2.18,0,0,0-1-.17h-.69V4.09h.73a2.17,2.17,0,0,0,.77-.11.7.7,0,0,0,.47-.71A.72.72,0,0,0,216.76,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.34,35.15V0h12.95V35.15Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "128.92 0.1 141.94 0.1 141.94 14.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "136.59 9.74 136.59 24.77 128.82 17.52 136.59 9.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "129.38 35.15 142.38 35.15 142.38 20.34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7e0d933589e3480a1623830b45db52a4.svg";
export { ForwardRef as ReactComponent };